import React from 'react';

import { GroupPickerField, GroupPickerFieldProps } from '@lumapps/group-pickers/components/GroupPickerField';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { useFormField } from '../../hooks/useFormField';
import { BaseInput } from '../../types';

export interface FormGroupPickerFieldProps
    extends BaseInput,
        Omit<GroupPickerFieldProps, 'label' | 'value' | 'onChange'> {
    /** whether the field is disabled or not  */
    isDisabled?: boolean;
}

/**
 * Component that connects the Group picker to our forms system.
 * @family Forms
 * @param FormGroupPickerFieldProps
 * @returns FormGroupPickerField
 */
export const FormGroupPickerField: React.FC<FormGroupPickerFieldProps & BaseInput> = ({
    name,
    controllerProps,
    isRequired,
    label,
    isDisabled,
    selectionType,
    ...props
}) => {
    const { translateKey } = useTranslate();
    const { field, valueToUse, isFormLoading, fieldState, scope } = useFormField({
        name,
        isRequired,
        controllerProps,
        label,
    });

    return (
        <GroupPickerField
            {...props}
            selectionType={selectionType as any}
            label={label}
            value={valueToUse}
            onChange={field.onChange}
            selectTextFieldProps={{
                inputRef: field.ref,
                isDisabled: isDisabled ?? isFormLoading,
                error: fieldState.error?.message || translateKey(GLOBAL.FIELD_IS_REQUIRED),
                name: field.name,
                isRequired,
                onBlur: field.onBlur,
                hasError: Boolean(fieldState.error),
                ...props.selectTextFieldProps,
                scope: `${scope}-group-picker-field`,
            }}
        />
    );
};
